import React, { Component } from 'react';
import Relay from 'react-relay/classic';
import { ActivityIndicator } from '@lyearn-team/frontend-components';

import PreviewCourse from '../crud-course/PreviewCourse';
import ViewerRoute from '../../../../learner/queries/ViewerRoute';
import User from '../../../../helper/currentUser';
import setupRelayEnvironment from '../../../../helper/relayEnvironment';
import request from '../../../../helper/NetworkLayer';

const user = new User();

setupRelayEnvironment();

class CourseSharePreview extends Component {
  constructor() {
    super();
    this.state = {
      course: null,
      loading: true
    };
  }

  componentDidMount() {
    this.getOffer(this.updateViewerRoute);
  }

  getOffer = async cb => {
    try {
      const unpublishedResponse = await this.getUnpublishedOfferPromise();
      const unpublishedJsonResponse = await unpublishedResponse.json();
      if (unpublishedJsonResponse === null) {
        const publishedResponse = await this.getPublishedOfferPromise();
        const publishedJsonResponse = await publishedResponse.json();
        this.updateCourse(publishedJsonResponse, cb);
      } else {
        this.updateCourse(unpublishedJsonResponse, cb);
      }
    } catch (error) {
      console.error(error);
    }
  };

  getUnpublishedOfferPromise = () =>
    request(
      '/getUnPublishedUnit',
      { method: 'GET' },
      { queryParams: { unitId: this.props.params.courseId } }
    );

  getPublishedOfferPromise = () =>
    request(
      '/getOffer',
      { method: 'GET' },
      { queryParams: { offerId: this.props.params.courseId } }
    );

  updateCourse = (course, cb) => {
    delete course._id;
    delete course.content._id;
    this.setState({ course }, cb);
  };

  updateViewerRoute = () => {
    this.viewerRoute = new ViewerRoute({
      courseInfo: JSON.stringify(this.state.course),
      userId: user.id() || '5e7de277beee070008721310',
      resolveLocally: true
    });
    this.setState({
      loading: false
    });
  };

  render() {
    const { course, loading } = this.state;
    if (loading) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh'
          }}
        >
          <ActivityIndicator width={30} height={30} />
        </div>
      );
    }
    return (
      <Relay.Renderer
        Container={PreviewCourse}
        render={({ done, props }) => {
          if (done && props) {
            return (
              <PreviewCourse
                {...props}
                params={this.props.params}
                courseInfo={JSON.stringify(course)}
              />
            );
          }
          return (
            <PreviewCourse
              loading={true}
              params={this.props.params}
              courseInfo={JSON.stringify(course)}
            />
          );
        }}
        environment={Relay.Store}
        queryConfig={this.viewerRoute}
        forceFetch={true}
      />
    );
  }
}

export default CourseSharePreview;
